import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import { useTranslation } from 'react-i18next';
import travelimg from '../../tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import SignatureCanvas from 'react-signature-canvas';
import Termplandownload from './Term-Plan Certificate.pdf';

const { config } = require('../../api/api');


function TermPlanQuestions() {

  const base_url = config.baseURL;

  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  const signatureRef = useRef();

  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    insurancetype: '',
  });
  const [loading, setLoading] = useState(false);
  const [form_download, setdownload] = useState(false);

  const handleDownload = () => {
    setdownload(true);
  };

  const handleqOptionChange = (event) => {

  };
  const [quotationData, setQuotationData] = useState(null);


  const [questionList, setQuestionList] = useState();

  const [questionsData, setQuestionsData] = useState([{
    english: '',
    arabic: '',
    key: '',
    accepted_answer: '',
    isChecked: '',
    isChecked_answer: '',
    details: ''
  }]);


  const [selectedValue, setSelectedValue] = useState('Yes');

  const handleChanges = (e) => {
    setSelectedValue(e.target.value);
  };
  function handleRadioChange(index, isChecked) {
    const updatedQuestionsData = [...questionsData];
    updatedQuestionsData[index] = {
      ...updatedQuestionsData[index],
      isChecked,
      isChecked_answer: isChecked ? "Yes" : "No"
    };
    if(questionsData[index].key === 'is_armed_member' && !isChecked){
      setdownload(true);
    }else if(questionsData[index].key === 'is_armed_member' && isChecked){
      setdownload(false);
    }
    setQuestionsData(updatedQuestionsData);
    // if (updatedQuestionsData[index].isChecked_answer != questionsData[index].accepted_answer){

    //   if (questionsData[index].accepted_answer != 'Null'){

    //   }
    // }
  }

  function handleDetailsChange(index, details) {

    const updatedQuestionsData = [...questionsData];
    updatedQuestionsData[index] = {
      ...updatedQuestionsData[index],
      details
    };
    setQuestionsData(updatedQuestionsData);
  }

  const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);
  const [isSignatureEmpty1, setIsSignatureEmpty1] = useState(true);


  const clearSignature = () => {
    signatureRef.current.clear();
    setIsSignatureEmpty(true);
    setIsSignatureEmpty1(true); // Disable button after clearing
  };
  const handleSignature = () => {
    if (!signatureRef.current.isEmpty()) {
      setIsSignatureEmpty(false);
      setIsSignatureEmpty1(false); // Enable button when signature is drawn
    }
  };
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


  const [isChecked1, setIsChecked1] = useState(false);
  const handleCheckboxChange1 = (event) => {
    setIsChecked1(event.target.checked);
  };


  const handleSubmit = async (event) => {

    event.preventDefault();
    setLoading(true);

    event.preventDefault();
    window.location.href = '/';



  };
  const [dhofarData, setDhofarData] = useState(false);
  const [age, setAge] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Referanceid, setReferanceid] = useState('');
  const [modalMessage, setModalMessage] = useState("");
  const [bmi, setbmi] = useState('')
  const [armedForceDocUrl, setArmedForceDocUrl] = useState('');
  useEffect(() => {


    const storedDhofarString = Cookies.get('personalData'); //sessionStorage.getItem('userData')
    debugger
    if (storedDhofarString !== undefined) {
      const storedDhofar = JSON.parse(storedDhofarString);
      setDhofarData(storedDhofar);
    }
    else {
      alert("token expired");
      window.location.href='/';
    }

  }, []);
  const [userData, setUserData] = useState();

  useEffect(() => {
    const storedUserString = Cookies.get('userData'); //sessionStorage.getItem('userData')
    if (storedUserString != undefined) {
      const storedUser = JSON.parse(storedUserString);
      setUserData(storedUser);
    } else {
      // alert("token expired");
      // window.location.href = '/';
    }
  }, []);

  const [vendorKey, setVendorkey] = useState('');

  useEffect(() => {

    const postvData = { organization_name: "Superjet" };
    debugger

    if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {


      fetch( base_url + '/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postvData),
      })
        .then(response => response.json())
        .then(data => {
          setVendorkey(data.result[0].vendor_key);
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });


    }
  }, [vendorKey]); // Dependency array

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const postData = { token: dhofarData };
  // const today = new Date().toISOString().split('T')[0];
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate() + 1).toISOString().split('T')[0];


  const [dobValue, setdobValue] = useState('');
  const handledobChange = (event) => {
    const selectedDob = event.target.value;
    setdobValue(event.target.value);

    const dobDate = new Date(selectedDob);
    const today = new Date();
    let calculatedAge = today.getFullYear() - dobDate.getFullYear();
    const monthDiff = today.getMonth() - dobDate.getMonth();

    // Adjust age if the current date is before the user's birthday in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
      calculatedAge--;
    }

    setAge(calculatedAge);
  };

  const [selectedgenderOption, setSelectedgenderOption] = useState(null);
  const [selectedgenderOptionid, setSelectedgenderOptionid] = useState(null);
  const handlegenderChange = (event) => {
    setSelectedgenderOptionid(event.target.options[event.target.selectedIndex].id);
    setSelectedgenderOption(event.target.value);
  };

  const [selectedmaritalOption, setSelectedmaritalOption] = useState(null);
  const [selectedmaritalOptionid, setSelectedmaritalOptionid] = useState(null);
  const handlemaritalChange = (event) => {
    setSelectedmaritalOptionid(event.target.options[event.target.selectedIndex].id);
    setSelectedmaritalOption(event.target.value);
  };
  //getgender

  const [questions, setquestionsValue] = useState([]);

  useEffect(() => {
    if (vendorKey !== '') {
      fetch(base_url + '/getdhofarquestionnairedocument', {
        headers: { 'Authorization': `Bearer ${vendorKey}` }
      })
        .then(r => r.json())
        .then(d => { if (d.success) setArmedForceDocUrl(d.data); })
        .catch(console.error);

      const fetchQuestions = async () => {
        try {
          debugger
          const response = await fetch(base_url + '/get_term_plan_questions', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${vendorKey}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData),
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          debugger
          setQuestionList(data.result.data);
          var questionsLists = data.result.data;

          questionsLists = questionsLists.map(question => ({
            english: question.English,
            arabic: question.Arabic,
            key: question.key,
            accepted_answer: question.accepted_answer,
            isChecked: '',
            details: '',
            isChecked_answer: ''
          }));

          const getQuestions=sessionStorage.getItem("personalquestionvalue");
          
          if(getQuestions!==undefined&&getQuestions!==null&&getQuestions!==""){
           const homeQuestions =JSON.parse(getQuestions);
          Object.keys(homeQuestions).forEach((prop)=>{
            const currentQuestion = questionsLists.find(question => question.key === prop);
               if (currentQuestion) {
               const updatedQuestionsData = [...questionsLists];
               const updatedQuestion = { ...currentQuestion, isChecked: homeQuestions[prop]==="Yes" ? true : false , isChecked_answer: homeQuestions[prop] };
               updatedQuestionsData[questionsLists.indexOf(currentQuestion)] = updatedQuestion;
               questionsLists = updatedQuestionsData;
  }

  });
          setQuestionsData(questionsLists);
        }
        else{
          setQuestionsData(questionsLists);
          }
        if(getQuestions!==undefined){
           const checkbox =JSON.parse(getQuestions);
           setIsChecked(checkbox.checkbox_checked);
          }
          // setQuestionsData(questionsLists);
        } catch (error) {
          console.error('Error fetching occupations:', error);
        }
      };

      fetchQuestions();
    }
  }, [vendorKey]);

  debugger
  console.log(questions)

  const api_headers = {
    'Authorization': 'Bearer ' + vendorKey,
    'Content-Type': 'application/json' // Ensure you're sending JSON
  }


  const [amount, setAmountValue] = useState('');
  const [policy, setPolicyValue] = useState('');

  const handleQotation = async (event) => {

    debugger 

      const bacsicinfojson = sessionStorage.getItem('personalaccidentbasicinfo');
    const basicinfo = JSON.parse(bacsicinfojson);

    const basicPremiumjson = sessionStorage.getItem('personalaccidentpremiumcover');
    const basicPremium = JSON.parse(basicPremiumjson);

    const addbenefityjson = sessionStorage.getItem('personalaccidentbeneficiaries');
    const addbenefity = JSON.parse(addbenefityjson);

    const personalinfojson = sessionStorage.getItem('persionalaccidentinformationpage');
    const personalinfo = JSON.parse(personalinfojson);

    function formatDOB(dob) {
      const date = new Date(dob);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }

    debugger

    var quotation_data =
    {
      "token": dhofarData,
      "cover_type": "Term Plan",
      "application_type": "self",
      "plan": "Term Plan",
      "nationality": personalinfo.nationality,
      "civil_id": personalinfo.civilid,
      "sum_assured": basicPremium.premium_valu,
      "personalInformation": {
        "fullName": personalinfo.fullName,
        "email": personalinfo.email,
        "mobileNumber": personalinfo.mobilenumber,
        "dob": formatDOB(basicinfo.dob),
        "resident_location": personalinfo.Residential_Location,
        "gender": basicinfo.basicinfo_gender_detail.toLowerCase(),
        "is_married": basicinfo.basicinfo_marital_status_detail.toLowerCase() === "single" ? 'no' : 'yes',
        "height": personalinfo.height,
        "weight": personalinfo.weight,
        "occupation": personalinfo.occupation,
        "passport": personalinfo.passportnumber,
        "vat_in": personalinfo.vat_in,
      },
      "beneficiaries": addbenefity.beneficiaries
    };
    if (vendorKey !== '') {
      // const fetchPolicy = async () => {
      try {

        const dd = await fetch(base_url + '/get_term_plan_quotation', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${vendorKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(quotation_data),
        });

        if (!dd.ok) {
          throw new Error('Network response was not ok');
        }
        debugger

        const data = await dd.json();

        setAmountValue(data.result.data.amount);
        sessionStorage.setItem("personalaccdientamount", JSON.stringify(data.result.data.amount))


        var questionvalue = questionsData.reduce((acc, q) => {
          acc[q.key] = q.isChecked_answer;
          return acc;
        }, {});
        questionvalue["signature"] = signatureRef.current.toDataURL();
        sessionStorage.setItem('personalquestionvalue', JSON.stringify(questionvalue))
        // await handlePolicy(data.result.data.amount)
        const signatureData=signatureRef.current.toDataURL();
        sessionStorage.setItem("ternSignature",signatureData);
        window.location.href = '/termplan-policy'
      } catch (error) {
        console.error('Error fetching occupations:', error);
      }
      // };
    }
 
  };






  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'Please answer the following' : 'الرجاء الإجابة على ما يلي\n'}</h3>
          </div>
        </div>


      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5">


              {questionsData.map((question, index) => (
                <div key={index}>
                  <p>{index+1}. {lnstr === 'en' ? question.english : question.arabic}</p>
                  <div className="custom-radio" style={{ color: '#3fd2f2' }}>
                    <input
                      type="radio"
                      id={`yes-${index}`}
                      name={`option-${index}`}
                      value="Yes"
                      checked={question.isChecked === true && question.isChecked_answer==="Yes"}
                      onChange={() => handleRadioChange(index, true)}
                    />
                    <label htmlFor={`yes-${index}`}> {(question.accepted_answer === 'Yes' || question.accepted_answer === 'No') ? 'Yes' : "I Agree"}</label>

                    <input
                      type="radio"
                      id={`no-${index}`}
                      name={`option-${index}`}
                      value="No"
                      checked={question.isChecked === false&& question.isChecked_answer==="No"}
                      onChange={() => handleRadioChange(index, false)}
                    />
                    <label htmlFor={`no-${index}`}>{(question.accepted_answer === 'Yes' || question.accepted_answer === 'No') ? "No" : 'I Disagree'}</label>
                  </div>
                  <br />
                  {question.key === 'is_armed_member' && question.isChecked_answer === 'Yes' ? (
                    <>
                     {lnstr=="en"?<span>Please download this </span>:<span>يرجى تنزيل هذا</span> }<a href={armedForceDocUrl} target="_blank" rel="noreferrer" onClick={handleDownload}>
                       {lnstr=="en"? <u>questionnaire</u>:<u>استطلاع</u>}
                        
                      </a>{ lnstr=="en"?<span>and fill it. You will be asked to upload the filled document after the payment.</span>:<span>ثم قم بملئه. سيُطلب منك تحميل المستند المكتمل بعد الدفع.</span>}
                     
                    </>
                  ) : ''}
                  {question.key !== 'is_armed_member' && question.isChecked_answer != '' && question.accepted_answer !== question.isChecked_answer && (
                    <div className='col-md-12'>
                      <textarea
                        style={{
                          height: '100px',
                          width: '100%'
                        }}

                        value={question.details || ''} // Ensure there's a default value
                        onChange={(e) => handleDetailsChange(index, e.target.value)}
                        placeholder="Please provide more details"
                      />
                    </div>
                  )}
                </div>
              ))}
              <br/>
              {lnstr=="en"? <b>Please put your signature here</b>:<b>من فضلك وقع هنا</b>}<br />

              <SignatureCanvas
               ref={(ref)=>{
                signatureRef.current=ref;
                const  storedSignature=sessionStorage.getItem("ternSignature");
                if(storedSignature && ref){
                  ref.clear();
                  ref.fromDataURL(storedSignature);
                  setIsSignatureEmpty(false);
                }

              }}
                penColor="black"
                canvasProps={{ width: 340, height: 200, className: 'sigCanvas' }}
                style={{ border: '1px solid #ccc', backgroundColor: 'white' }} // Ensure background is white
                onEnd={handleSignature} // Detect when drawing ends
              />
              <div>
                <button type="button"
                  style={{ backgroundColor: !isSignatureEmpty ? '#1D3561' : 'grey', borderColor: '#1D3561' }}
                  className="btn btn-primary rounded-pill text-white my-3 py-1 " onClick={async () => {
                    clearSignature();
                  }}
                  disabled={isSignatureEmpty}
                >
                   {t("Clear Signature")}
                </button>
              </div>



              <p ><input type="checkbox" checked={isChecked}
                onChange={handleCheckboxChange} name="note" />
                {lnstr=="en" ? <span> I hereby declare that I have personally read and answered the above question  and answer to the above question is complete and true to the best of my knowledge and belief, I am aware the above question forms part of the contract, that may be issued on the strength thereof.</span>:<span>أعلن بموجب هذا أنني قرأت وأجبت شخصيًا على السؤال أعلاه وأن إجابتي على السؤال أعلاه كاملة وصحيحة على حد علمي ومعتقدي، وأنا أدرك أن السؤال أعلاه يشكل جزءًا من العقد، والذي يجوز إصداره بناءً عليه.</span>}
              </p>
              <p ><input type="checkbox" checked={isChecked1}
                onChange={handleCheckboxChange1} name="note" />
                {lnstr=="en"?<span> I agree to the following </span>:<span>أوافق على ما يلي</span>} <a href={Termplandownload} download='Term-Plan Certificate.pdf'>{lnstr=="en"?<u>Term Plan Certificate</u>:<u>شهادة خطة المدة</u>}</a>
              </p>
              <div className='col-md-2 text-center'>
                <button type="button"
                // disabled={!isChecked || !isChecked1}
                  style={{ backgroundColor: isChecked ? '#1D3561' : "grey", borderColor: '#1D3561' }}
                  className="btn btn-primary rounded-pill text-white my-3 py-2 "
                  // disabled={isChecked ? false : true}
                  onClick={async () => {


                    var question_valid = !questionsData.some(q => q.isChecked_answer === '');
                    const armedMember = questionsData.find(q => q.key === 'is_armed_member');
                    const invalidQuestion = questionsData.findIndex(q => q.isChecked_answer !== '' && q.isChecked_answer !== q.accepted_answer && q.key !== 'is_armed_member');
                    if (!question_valid) {
                      alert('Please ensure the question answer');
                    } else if (invalidQuestion !== -1 && questionsData[invalidQuestion].details === '') {
                      alert(`Please provide details for question ${invalidQuestion + 1}`);
                    }else if (armedMember && armedMember.isChecked_answer !== 'No' && form_download !== true){
                      alert("Please download the questionnaire document")
                    }else if (signatureRef.current.isEmpty()) {
                      alert('Please put signature');
                    } else if (!isChecked) {

                      alert('Please ensure the declare');
                    } else if (!isChecked1) {

                      alert('Please ensure the declare');
                    } else {
                      debugger
                      // event.preventDefault();



                      setLoading(true);

                      await handleQotation();
                    }

                  }}
                >
                  {t("Proceed")}
                </button>
              </div>


            </Col>


            <Col md={3}></Col>

          </div>

        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );
}

export default TermPlanQuestions;
